module.exports = __webpack_public_path__ + "img/mic2.7f59ab92.jpg";